import CustomButton from '../../../Components/CustomButton'
import './styles.scss'

const InfoCard = ({ onClick, text, btnLabel }) => {
  const lines = text.split('\n').filter(Boolean)

  return (
    <div className="home-page__info-card">
      <span className="home-page__info-card__tagline">Connecting Every Corner</span>
      <h1 className="home-page__info-card__headline">
        {lines.map((line, i) => (
          <span key={i} className="line">{line}</span>
        ))}
      </h1>
      <CustomButton label={btnLabel} onClick={onClick} />
    </div>
  )
}

export default InfoCard
